export default __webpack_public_path__ + "static/media/Gujarati Health Education Social Security Schemes booklet.ee054280.pdf";